import appConfig from './main';
import render from '$app/render/client';
import { retry } from './utils/retry';
/**
 * Client entry point to create the client bundle
 */

// onclick = () => {
//   render(appConfig.createApp, import.meta.env.APP_NAME);
// };

async function waitForSelector(selector: string) {
  const el = document.querySelector(selector);

  if (!el) {
    throw new Error('Selector not found yet');
  }

  return el;
}

async function hydrateWithRetry() {
  try {
    await retry(
      () => waitForSelector('[data-component-name="owvans-technical-data"]'),
      10, // retries
      500, // delay ms
    );

    render(appConfig.createApp, import.meta.env.APP_NAME);
  } catch (e) {
    console.error('selector not found, cannot hydrate', e);
  }
}

hydrateWithRetry();
